import React, {  useEffect, useState } from 'react'
import { loadUserTalent, loadUserTalentDocuments, loadUserTalentGallery } from '../utils/Network';

import {  getDefaultName } from '../utils';
import UserTalentDocument from '../components/UserTalentDocument';
import UserTalentGalleryItem from '../components/items/UserTalentGalleryItem';
import Modal from 'react-modal';
import UserTalentGalleryForm from '../components/forms/UserTalentGalleryForm';
import UserTalentDocumentForm from '../components/forms/UserTalentDocumentForm';

export default function UserTalentSingleContent({ id, callback, onDocumentsCountChange }) {

    const [userTalent, setUserTalent] = useState(null);
    const [userTalentDocuments, setUserTalentDocuments] = useState(null);
    const [userTalentGalleries, setUserTalentGalleries] = useState(null);
    const [addModalIsOpen, setAddModalIsOpen] = useState(false);
    const [addUserDocumentModalIsOpen, setAddUserDocumentModalIsOpen] = useState(false);
    const [loading, setLoading] = useState(false);

    

    useEffect(() => {

        if (id) {
            loadUserTalent(id).then(usertalent => {
                setUserTalent(usertalent);
            });

            _getUserTalentDocuments()

            // _getUserTalentGalleries()
            
        }


    }, [id]);

    const _getUserTalentDocuments = () => {
        loadUserTalentDocuments(id).then((userTalentDocuments) => {
            setUserTalentDocuments(userTalentDocuments);
            const len = Array.isArray(userTalentDocuments) ? userTalentDocuments.length : 0;
            if (typeof onDocumentsCountChange === "function") {
                onDocumentsCountChange(len);
            }
        });
    };

    const closeModal = () => {
        setAddModalIsOpen(false)
    }

    const closeUserDocumentModal = () => {
        setAddUserDocumentModalIsOpen(false)
    }

    // const _getUserTalentGalleries = () => {
    //     setLoading(true)
    //     loadUserTalentGallery(id).then(userTalentGalleries => {
    //         setUserTalentGalleries(userTalentGalleries);
    //         setLoading(false)
    //     });
    // }

    const openModal = (current_document) => {
        callback(current_document)
    }

    const getDocumentName = () => {
        if (userTalent && userTalent.talent && userTalent.talent.documents) {
            if (userTalent.talent.documents.length > 0)
                return getDefaultName(userTalent.talent.documents[0].names) + "s";
        }
        return "";
    }

    return (
        <>
            <Modal
                closeTimeoutMS={500}
                isOpen={addUserDocumentModalIsOpen}
                onRequestClose={closeUserDocumentModal}
                className="Modal"
                overlayClassName="Overlay"
            >
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close" onClick={closeUserDocumentModal}>
                            <span aria-hidden="true">&times;</span>
                        </button>
                        <h4 class="modal-title">Add Document</h4>
                    </div>
                    <div class="modal-body text-center">
                        <UserTalentDocumentForm key={userTalent} usertalent={userTalent && userTalent} callback={()=>{ setAddUserDocumentModalIsOpen(false); _getUserTalentDocuments() }} />
                    </div>

                </div>
            </Modal>
            {/* <Modal
                closeTimeoutMS={500}
                isOpen={addModalIsOpen}
                onRequestClose={closeModal}
                className="Modal"
                overlayClassName="Overlay"
            >
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close" onClick={closeModal}>
                            <span aria-hidden="true">&times;</span>
                        </button>
                        <h4 class="modal-title">Add Gallery</h4>
                    </div>
                    <div class="modal-body text-center">
                        <UserTalentGalleryForm usertalent={userTalent && userTalent.id} callback={()=>{ setAddModalIsOpen(false); _getUserTalentGalleries() }} />
                    </div>

                </div>
            </Modal> */}

            <div className="usertalent-documents-wrap">
                <div className="usertalent-documents-toolbar">
                    <span className="usertalent-documents-label">Documents</span>
                    <button
                        type="button"
                        className="btn btn-cm btn-sm"
                        onClick={() => setAddUserDocumentModalIsOpen(true)}
                        title="Add document"
                    >
                        <i className="fa fa-plus" />
                    </button>
                </div>
                <div className="usertalent-documents-list">
                    {userTalentDocuments && userTalentDocuments.length > 0 ? (
                        userTalentDocuments.map((item) => (
                            <UserTalentDocument
                                key={item.id}
                                openModal={openModal}
                                callback={_getUserTalentDocuments}
                                item={item}
                                usertalent={id}
                            />
                        ))
                    ) : (
                        <p className="usertalent-documents-empty">No documents uploaded yet.</p>
                    )}
                </div>
            </div>

        </>


    )

}
